import {
    apiTransitionPaystack,
    apiTransitionPaystackStatus,
    checkPaymentsStatus,
    checkPaystackStatusSuccess,
    initPayments,
    submitPaymentSuccess,
    submitPaystackPayments,
} from '../../../actions/ugMotorInsurance/paystack';
import { setExpiredAuth } from '../../../actions/ugMotorInsurance/quote';
import {
    getAccessToken,
    getPaystackData,
    getPaystackIsApiPending,
    getPaystackStatusIsApiPending,
    getPaystackStatusIsApiStatus,
    getPaymentsForm,
} from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import {
    getCustomerIdValue,
    getInsuranceQuotationIdValue,
    getPremiumCalculationUg,
    getSelectedCover,
} from '../../../selectors/ugMotorInsurance/quote';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import { confirmOrderSuccess } from '../../../actions/ugMotorInsurance/payments';

const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
};

let intervalId = null;

// ---------------------------- INITIATE PAYMENT --------------------
export const paystackPaymentService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (!getPaystackIsApiPending(state)) {
            store.dispatch(apiTransitionPaystack.pending());
            try {
                let resp;

                const selectedCover = getSelectedCover(state);

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await initiateComprehensivePaystackPayments(state);
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await initiateThirdPartyPaystackPayments(state);
                }
                if (resp.data) {
                    store.dispatch(submitPaymentSuccess(resp.data));
                    store.dispatch(apiTransitionPaystack.success());
                }
                intervalId = setInterval(() => {
                    store.dispatch(checkPaymentsStatus());
                    if (getPaystackStatusIsApiStatus(state) === 'success') {
                        clearIntervalId(intervalId);
                    }
                }, 5000);
                setTimeout(() => {
                    if (intervalId) {
                        clearIntervalId(intervalId);
                        store.dispatch(submitPaystackPayments());
                        store.dispatch(apiTransitionPaystackStatus.failure());
                        return;
                    }
                }, 240000);
            } catch (e) {
                store.dispatch(apiTransitionPaystack.failure());
                //store.dispatch(triggerPaymentsStkPushFailure(e.response));
                clearIntervalId(intervalId);
                return e;
            }
        }
    })();
    return result;
};

const initiatePayload = (state) => {
    const pid = getCustomerIdValue(state);
    const insuranceQuoteationId = getInsuranceQuotationIdValue(state);
    const premium = getPremiumCalculationUg(state);
    const selectedCover = getSelectedCover(state);

    //   const channel = getPaymentsForm(state);

    let payload;

    if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
        payload = {
            quotation_id: insuranceQuoteationId.value,
            customer_id: pid.value,
            amount: premium.value.premium || premium.value.totalPremium,
            product_category: 'MOTOR',
            product_code: 'MOTORINSURANCEKE',
            // channel: channel,
        };
    }

    if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
        payload = {
            quote_id: pid.value,
            amount: premium.value.premium || premium.value.totalPremium,
            product_category: 'MOTOR',
            product_code: 'MOTORINSURANCEKE',
            // channel: channel
        };
    }

    return {
        ...payload,
    };
};

const initiateComprehensivePaystackPayments = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/paystack-initiate';

        return await axios.post(url, initiatePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        throw e;
    }
};

const initiateThirdPartyPaystackPayments = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ke-motor-insurance/third-party/paystack-initiate';

        return await axios.post(url, initiatePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        throw e;
    }
};

// ---------------------------- END -------------------

// ---------------------------- CHECK STATUS --------------------
export const paystackStkStatusService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    (async () => {
        if (getPaystackStatusIsApiStatus(state) === 'success') {
            clearIntervalId(intervalId);
            intervalId = null;
            return;
        }
        if (!getPaystackStatusIsApiPending(state)) {
            store.dispatch(apiTransitionPaystackStatus.pending());
            try {
                const resp = await triggerStkStatusCheck(state);
                if (resp.data && resp.data.success) {
                    if (resp.data.data.data.status === 'success') {
                        clearIntervalId(intervalId);
                        intervalId = null;
                        store.dispatch(checkPaystackStatusSuccess(resp.data));
                        store.dispatch(submitPaystackPayments());
                        store.dispatch(apiTransitionPaystackStatus.success());
                    } else {
                        store.dispatch(apiTransitionPaystackStatus.initialize());
                    }
                    return;
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                //store.dispatch(apiTransitionPaymentsStatus.failure());
                console.error(e.response);
                //store.dispatch(checkPaymentsStatusFailure(e.response));
                return e;
            }
        }
    })();
    return result;
};

const paystackStatusPayload = (state) => {
    const paystackData = getPaystackData(state);
    const payload = {
        reference_code: paystackData.response.data.reference || null,
    };
    return {
        ...payload,
    };
};

const triggerStkStatusCheck = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/paystack-status';
        return await axios.post(url, paystackStatusPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
// ---------------------------- END -------------------

// ---------------------------- SUBMIT PAYMENT --------------------

export const submitPaymentService = (store, next, action) => {
    const state = store.getState();
    (async () => {
        try {
            const selectedCover = getSelectedCover(state);

            let resp;

            if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                resp = await triggerSubmit(store.getState());
            }
            if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                resp = await triggerThirdPartySubmit(store.getState());
            }

            if (resp.data && resp.data.status === 200) {
                store.dispatch(confirmOrderSuccess(resp.data));
            }
        } catch (e) {
            console.error(e);
        }
    })();

    return next(action);
};

const paystackSubmitPayload = (state) => {
    const paystackData = getPaystackData(state);
    const pid = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);
    // add quotation id
    const payload = {
        customer_id: pid.value,
        quotation_id: insuranceQuotationId.value,
        reference_code: paystackData.response.data.reference || null,
    };
    return {
        ...payload,
    };
};

const paystackThirdPartySubmitPayload = (state) => {
    const pid = getCustomerIdValue(state);
    const paystackData = getPaystackData(state);

    const payload = {
        quote_id: pid.value,
        reference_code: paystackData.response.data.reference || null,
    };

    return {
        ...payload,
    };
};

const triggerSubmit = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/paystack-payment-submit';
        return await axios.post(url, paystackSubmitPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const triggerThirdPartySubmit = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ke-motor-insurance/third-party/paystack-payment-submit';
        return await axios.post(url, paystackThirdPartySubmitPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                // Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
// ---------------------------- END -------------------
